import React from "react";
import Pod from "carbon-react/lib/components/pod";

import "./PageBanner.css";

const PageBanner = (props) => {
  return (
    <div className="page-banner">
      <Pod
        as="primary"
        podType="tile"
        border
        alignTitle="center"
        title={props.title}
        {...props}
      >
        {props.children}
      </Pod>
    </div>
  );
};

export default PageBanner;
